import { combineReducers } from 'redux';
import { singleValueReducer } from 'store/reducerUtils';
import { setOpenPromotionDemotion } from 'modules/subassignmentManagement/components/PromotionDemotion/store/actions';

const isOpen = singleValueReducer(setOpenPromotionDemotion.action, false);

export const promotionDemotion = combineReducers({
    isOpen,
});
